import React from 'react';

import Table from '~/src/containers/Table';
import { DrillDownPanelLink, DrillDownPanelButton } from '../DrillDownPanel';
import { ReactComponent as InformationIcon } from './information-icon.svg';
import { REQUEST_COURT_FORM_URL } from '~/src/constants/externalLinks';

const RequestCourtForm = () => (
  <div className="mt-2">
    <InformationIcon className="mr-2 mb-1" />
    <span className="mr-2">Can&apos;t find the forms you are looking for?</span>
    <a href={REQUEST_COURT_FORM_URL} target="_blank" rel="noreferrer">
      Request a form
    </a>
  </div>
);

export const normalizeLocality = (locality) => {
  return locality.replaceAll(' ', '_');
};

export const denormalizeLocality = (normalizedLocality) => {
  return normalizedLocality.replaceAll('_', ' ');
};

const StateRegionTable = ({
  actionType,
  pdfCourtForms,
  visibleItems,
  empty,
  onSearchChange,
  handleClick,
  routeUrl = '/library/court-forms',
  columnLabel = 'Region',
  searchPlaceholder = 'Search regions',
}) => {
  const renderLocalityColumnButton = (columnData, { rowData }) => (
    <DrillDownPanelButton
      label={rowData.locality}
      handleClick={() => handleClick(rowData.locality)}
    />
  );

  const renderLocalityColumnLink = (columnData, { rowData }) => (
    <DrillDownPanelLink
      label={rowData.locality}
      linkUrl={`${routeUrl}/${rowData.filterCategory}/${normalizeLocality(
        rowData.locality,
      )}/form-listing`}
      noBorder={true}
    />
  );

  return (
    <div className="flex">
      <Table
        emptyTitle={'No localities match that filter'}
        empty={empty}
        isLoading={false}
        searchPlaceholder={searchPlaceholder}
        data={pdfCourtForms}
        visibleItems={visibleItems}
        onSearchChange={onSearchChange}
        isSortByDisabled={
          true
        } /* since backend library(typesense) does NOT support sorting by string value, https://github.com/typesense/typesense/issues/117, https://github.com/typesense/typesense/issues/90 */
        columns={[
          {
            label: columnLabel,
            dataKey: 'locality',
            render:
              actionType === 'button'
                ? renderLocalityColumnButton
                : renderLocalityColumnLink,
            style: {
              padding: '0',
              margin: '0px 0px 0px 3px',
              width: '100%',
              textAlign: 'left',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
            },
          },
        ]}
        renderActions={() => <RequestCourtForm />}
      />
    </div>
  );
};

export default StateRegionTable;
